import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Box, Typography, Grid, Pagination, Container, Card, Modal, Button, InputAdornment, TextField, CircularProgress } from '@mui/material';
import { Dialog, DialogContentText, DialogContent, DialogTitle, DialogActions } from '@mui/material';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import PersonIcon from '@mui/icons-material/Person';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import LeadService from '../../core/services/leadsService';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { format } from 'date-fns';
import { debounce, throttle } from 'lodash';
import LinearProgress from '@mui/material/LinearProgress';
import { Paper, Stack } from '@mui/material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import toast from 'react-hot-toast';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { Autocomplete } from '@mui/material';
import '../ServicesMenu/servicesMenu.css';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import Slide from '@mui/material/Slide';
import LogoutExpiredModal from '../../components/LogoutExpiredModal';
const useStyles = makeStyles((theme) => ({
    tableForSales: {
        // [theme.breakpoints.down('md')]: {
        //     width: '1070px',
        // },
        // [theme.breakpoints.between('md', 'xmd')]: {
        //     width: '1150px',
        // },
        // [theme.breakpoints.down('lg')]: {
        //     width: '1070px',
        // },
    },
}));
const SalesReferralUsers = () => {
    const [referralUsers, setReferralUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();
    const classes = useStyles();
    const userData = JSON.parse(localStorage.getItem('user'));
    const userType = userData?.user?.user_type;
    const GetReferralUsersForSale = async (searchTerm) => {
        try {
            setLoading(true);
            let res;
            if (userType === 'admin') {
                res = await LeadService.AdminReferralSalesUsers(searchTerm);
            } else if (userType === 'sales') {
                res = await LeadService.GetReferralSalesUsers(searchTerm);
            } else {
                console('Invalid user type');
            }
            if (res?.data?.success) {
                setReferralUsers(res?.data?.data);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoading(false);
            setLoading(false);
        }
    };
    useEffect(() => {
        GetReferralUsersForSale(searchTerm);
    }, [searchTerm]);

    const handleNavigateReferralDetails = (parentId, name, last_name) => {
        navigate(`/referralSalesDetails/${parentId}`, {
            state: {
                name: name,
                last_name: last_name,
            },
        });
    };
    const columns = [
        {
            accessorKey: 'id',
            header: 'Sr no',
            size: 40,
            muiTableBodyCellProps: {
                align: 'left',
            },
        },
        {
            accessorKey: 'profile_image',
            header: '',
            Cell: ({ row }) => (
                <div style={{ display: 'flex' }}>
                    <Avatar src={`https://iconnctapp.com/` + row?.original?.profile_image} />
                </div>
            ),
            size: 10,
            enableSorting: false,
        },
        {
            accessorFn: (row) => {
                if (row?.last_name === null) {
                    return row?.name;
                } else {
                    return `${row?.name} ${row?.last_name}`;
                }
            },
            header: 'User Name',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
        },
        {
            accessorKey: 'email',
            header: 'Email ID',
            size: 140,
            // enableClickToCopy: true,
        },
        {
            accessorKey: 'referral_code',
            header: 'Referral Code',
            size: 140,
            // enableClickToCopy: true,
        },
        {
            accessorKey: 'import',
            header: 'Organization',
            size: 140,
            // enableClickToCopy: true,
        },
        {
            accessorKey: 'user_type',
            header: 'User Type',
            size: 80,
            enableSorting: false,
        },
        {
            id: 'actions',
            enableSorting: false,
            header: 'See More',
            size: 100,
            Cell: ({ row }) => (
                <div style={{ display: 'flex' }}>
                    <IconButton
                        aria-label="view"
                        onClick={() => handleNavigateReferralDetails(row?.original?.id, row?.original?.name, row?.original?.last_name)}
                    >
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <VisibilityIcon />
                        </div>
                    </IconButton>
                </div>
            ),
        },
    ];
    const handleSearchTerm = (e) => {
        setSearchTerm(e.target.value);
    };
    const handleClear = () => {
        setSearchTerm('');
    };
    return (
        <div>
            <div style={{ marginBottom: '15px' }}> {loading && <LinearProgress />}</div>
            <Box style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                <TextField
                    value={searchTerm}
                    onChange={handleSearchTerm}
                    sx={{
                        width: {
                            xs: "150px",
                            sm: "200px",
                            md: "250px"
                        },
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '12px',
                        },
                    }}
                    placeholder="Search by name , email"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={handleClear} aria-label="clear search">
                                    <ClearIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    variant="outlined"
                />
            </Box>
            <Box className={classes.tableForSales}>
                <Card style={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                    <MaterialReactTable
                        columns={columns}
                        data={referralUsers}
                        state={{ isLoading: isLoading }}
                        muiCircularProgressProps={{
                            color: 'secondary',
                            thickness: 5,
                            size: 55,
                        }}
                        muiSkeletonProps={{
                            animation: 'pulse',
                            height: 28,
                        }}
                        enableTopToolbar={false}
                        enableFacetedValues={true}
                        enableStickyHeader={true}
                        enableDensityToggle={false}
                        enableHiding={false}
                        showSkeletons={false}
                        enableColumnFilterModes={false}
                        enableColumnActions={false}
                        enableColumnOrdering={false}
                        enableFullScreenToggle={false}
                        enableColumnFilters={false}
                        enablePagination={false}
                        getRowId={(row) => row.id}
                        initialState={{
                            showColumnFilters: false,
                            showGlobalFilter: false,
                        }}
                        muiTableBodyRowProps={{
                            sx: {
                                backgroundColor: '#f5f5f5', // Default row background color
                                '&:nth-of-type(odd)': {
                                    backgroundColor: '#ffffff', // Alternate rows with white
                                },
                                '&:hover': {
                                    backgroundColor: '#e0e0e0', // Hover effect
                                    cursor: 'pointer',
                                },
                            },
                        }}
                    />
                </Card>
                {/* <Pagination
                        count={totalPages}
                        color="primary"
                        page={currentPage}
                        onChange={(event, value) => setCurrentPage(value)}
                        style={{ marginTop: '-40px', zIndex: 1000, position: 'relative', display: 'flex', justifyContent: 'flex-end' }}
                    /> */}
            </Box>
        </div>
    );
};

export default SalesReferralUsers;
